function getConfig() {
  return window.theme?.clickAndCollect || {};
}

function isWeekend(date) {
  const day = date.getDay();
  return day === 0 || day === 6;
}

export function addBusinessDays(startDate, days, allowWeekends) {
  const result = new Date(startDate);
  let remaining = Math.max(0, Number(days) || 0);

  while (remaining > 0) {
    result.setDate(result.getDate() + 1);
    if (!allowWeekends && isWeekend(result)) continue;
    remaining -= 1;
  }

  return result;
}

function formatEtaDate(date) {
  return date.toLocaleDateString(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
}

function getWaitDaysForSku(skuStatus, config) {
  const waitDays = config.waitDays || {};
  const enabled = config.waitDaysEnabled || {};

  if (!skuStatus) {
    return enabled.partialTransfer ? (waitDays.partialTransfer || 0) : 0;
  }

  if (skuStatus.status === 1) {
    return enabled.inStore ? (waitDays.inStore || 0) : 0;
  }

  if (skuStatus.warehouseAvailable && config.warehouseTransferEnabled) {
    return enabled.warehouse ? (waitDays.warehouse || 0) : 0;
  }

  return enabled.partialTransfer ? (waitDays.partialTransfer || 0) : 0;
}

export function calculateSkuCollectionDate(skuStatus, config = getConfig()) {
  const waitDays = getWaitDaysForSku(skuStatus, config);
  const allowWeekends = Boolean(config.allowWeekends);
  return addBusinessDays(new Date(), waitDays, allowWeekends);
}

export function calculateBoutiqueEta(boutique, skus = [], config = getConfig()) {
  if (!boutique) return '';

  const skuMap = new Map((boutique.skuStatuses || []).map((s) => [s.sku, s]));
  const dates = skus.map((sku) => calculateSkuCollectionDate(skuMap.get(sku), config));

  if (!dates.length) {
    return boutique.etaFormatted || '';
  }

  const effectiveDate = dates.reduce((latest, current) => (current > latest ? current : latest));
  return formatEtaDate(effectiveDate);
}

export function applyEtaToBoutiques(boutiques, skus = [], config = getConfig()) {
  return boutiques.map((boutique) => {
    const etaFormatted = calculateBoutiqueEta(boutique, skus, config);
    return { ...boutique, etaFormatted, eta: etaFormatted };
  });
}
